var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.BModal,
    {
      attrs: {
        size: "lg",
        "modal-class": "vue-need-bootstrap",
        title: "Variants Selector",
        lazy: "",
        centered: "",
        "hide-footer": "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
      },
      on: { close: _setup.onClose },
      model: {
        value: _setup.isVisible,
        callback: function ($$v) {
          _setup.isVisible = $$v
        },
        expression: "isVisible",
      },
    },
    [
      _setup.step === "selectVariants"
        ? _c("div", [
            _c(
              "div",
              [
                _setup.user
                  ? _c(_setup.StoreSelector, {
                      attrs: {
                        stores: _setup.user.Stores,
                        title: "Select store to retrieve POD information",
                        "include-no-billing": "",
                      },
                      model: {
                        value: _setup.storeUrl,
                        callback: function ($$v) {
                          _setup.storeUrl = $$v
                        },
                        expression: "storeUrl",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _setup.loadingVariants
              ? _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c("b-spinner", {
                      staticClass: "my-2",
                      attrs: { variant: "primary" },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _setup.podService
                      ? _c(_setup.VariantsConfigurator, {
                          attrs: {
                            "pod-service": _setup.podService,
                            "selected-print-providers":
                              _setup.selectedPrintProviders,
                            "selected-product-id": _setup.selectedProductId,
                            "selected-template-id": _setup.props.templateId,
                            store: _setup.storeUrl,
                            configurations: _setup.configurations,
                            "show-variants-details": true,
                            "allowed-placeholders": _setup.allowedPlaceholders,
                          },
                          on: {
                            "variants-selected": _setup.onVariantsSelected,
                            "delete-template-product":
                              _setup.onDeleteTemplateProduct,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _setup.step === "finalRevision"
        ? _c(
            "div",
            { staticClass: "col" },
            [
              _setup.podService
                ? _c(_setup.RevisionStep, {
                    attrs: {
                      "pod-service": _setup.podService,
                      "product-title": _setup.productTitle,
                      "provider-variants": _setup.selectedProviderVariants,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  staticClass: "float-right",
                  attrs: { variant: "primary" },
                  on: { click: _setup.onSave },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }